import type { StoryModel } from './story-model';
import type { TimelinePositionEngine } from './use-timeline-position';
import { useTimeWheelCanvas } from './use-time-wheel-canvas';

interface TimeWheelProps {
  readonly model: StoryModel;
  readonly engine: TimelinePositionEngine;
}

export function TimeWheel({ model, engine }: TimeWheelProps) {
  const { canvasRef, wrapperRef, currentDateRef, currentPeriodsRef, currentPeriodBadgeRef } =
    useTimeWheelCanvas({
      model,
      engine,
    });

  return (
    <aside className="relative h-full w-[170px] shrink-0 border-r border-white/10 bg-surface">
      <div ref={wrapperRef} className="h-full w-full px-2 py-4">
        <canvas ref={canvasRef} aria-hidden className="h-full w-full rounded-md" />
      </div>
      <div className="pointer-events-none absolute left-full top-1/2 z-20 ml-2 -translate-y-[calc(50%+20px)]">
        <span
          ref={currentPeriodBadgeRef}
          className="hidden max-w-[32ch] whitespace-nowrap rounded-full border px-3 py-1 text-xs font-semibold shadow-sm backdrop-blur"
        />
      </div>
      <div className="sr-only">
        <p>
          Aktiv tid: <span ref={currentDateRef}>-</span>
        </p>
        <p>
          Aktive perioder: <span ref={currentPeriodsRef}>Ingen aktiv periode</span>
        </p>
      </div>
    </aside>
  );
}
